<template>
  <!-- display: none - to hide this... -->
  <div
    v-if="false"
    class="notif-wrapper"
    :class="isClosed ? 'notif-wrapper__close' : ''"
  >
    <div class="container d-flex justify-content-center flex-wrap row m-auto">
      <font-awesome-icon
        icon="exclamation-triangle"
        class="danger-icon m-auto"
      />
      <div
        class="col-10 left text-center"
        style="color:#000;"
      >
        <span>
          Estamos tendiendo problemas en verificar el correo de Hotmail y outlook. 
          Por favor usa gmail u otro tipo de correo alternativo. Gracias por tu paciencia.
        </span>
      </div>
      <font-awesome-icon
        icon="times"
        class="accept-icon btn-accept m-auto"
        @click="accept"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isClosed: false
    }
  },
  mounted() {
    // Delete old accepted flag from storage
    if(localStorage.getItem('acceptedNotif')) {
      this.isClosed = (localStorage.removeItem('acceptedNotif'));
    }
    // Get new flag
    // if(localStorage.getItem('acceptedNotifHotmail')) {
    //   this.isClosed = (localStorage.getItem('acceptedNotifHotmail'));
    // }
  },
  methods: {
    accept() {
      // localStorage.setItem('acceptedNotifHotmail', true);
      this.isClosed = true;
    }
  }
}
</script>

<style lang="scss">
  .notif-wrapper {
    background: #eaff40b0;
    width: 100%;
    position: fixed;
    z-index: 10;
    padding: 5px;
    transition: all 1s ease-out;
    top: 0;
    height: 50px;
    &__close {
        top: -50px;
    }
    @media screen and (max-width: 767px) {
      & {
        height: 100px;
      }

      &__close {
        top: -100px;
      }

      .accept-icon {
        font-size: 1.2rem;
      }
    }
    .left {
      color: white;
      font-size: 0.8rem;
      text-align: left;
      a {
        color: white;
        font-weight: 600;
        text-decoration: underline;
      }
    }
    .btn-accept {
      cursor: pointer;
    }
    @media screen and (min-width: 767px) {
      .left {
        margin-right: 25px;
      }
    }
  }

  .danger-icon {
    font-size: 1.4rem;
  }
</style>